var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.loading)?_c('LoadingBar'):[_c('ClientAddress'),_c('ClientAddresses')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }